import { ReactNode } from 'react';
import { Box, lighten, SxProps, Theme } from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import { InfoOutlinedIcon, LanguageIcon } from '@occc-app/design-system';
import { useTheme } from '@mui/material/styles';

type InfoBoxType = 'warning' | 'info' | 'inter';

type InfoBoxProps = {
  type?: InfoBoxType;
  children?: ReactNode;
  sx?: SxProps;
};

type GetInfoBoxCustomizationProps = {
  theme: Theme;
  type: InfoBoxType;
};

const getInfoBoxCustomization = ({ theme, type }: GetInfoBoxCustomizationProps) => {
  const { palette } = theme;

  const typeMap = {
    warning: {
      icon: <WarningAmberOutlined sx={{ color: palette.warning.main }} />,
      backgroundColor: lighten(palette.warning.light, 0.9),
    },
    info: {
      icon: <InfoOutlinedIcon sx={{ color: palette.info.main }} />,
      backgroundColor: lighten(palette.primary.main, 0.9),
    },
    inter: {
      icon: <LanguageIcon sx={{ color: palette.info.main }} />,
      backgroundColor: lighten(palette.primary.main, 0.9),
    },
  };

  return typeMap[type];
};

export const InfoBox = (props: InfoBoxProps) => {
  const { type = 'info', children, sx } = props;
  const { icon, backgroundColor } = getInfoBoxCustomization({ theme: useTheme(), type });

  return (
    <Box
      p={2}
      borderRadius={1}
      display='flex'
      alignItems='center'
      gap={1.5}
      bgcolor={backgroundColor}
      sx={sx}
    >
      {icon}
      {children}
    </Box>
  );
};
